import React, { useState } from "react";


function TrainSchedule() {
    const [Nschedule, setNSchedule] = useState(null);
    const [Sschedule, setSschedule] = useState(null);
    const [station, setStation] = useState(null);
    
    function dateCreate(station) {
        let apiUrl = "https://www3.septa.org/hackathon/Arrivals/" + station + "/2/";
        console.log(apiUrl)
        if (station !== null) {
            fetch("https://cors-anywhere.herokuapp.com/" + apiUrl,
            {
                method: 'GET', 
                headers: { 'Content-Type': 'application/x-www-form-urlencoded', }
            })
                .then(response => response.json())
                .then(data => {
                    var object = Object.keys(data)[0];
                    setNSchedule(data[object][0]["Northbound"]);
                    setSschedule(data[object][1]["Southbound"]);
                });
            }
        }
    function convert24to12time(timeString) {
        var H = +timeString.substr(0, 2);
        var h = H % 12 || 12;
        var ampm = (H < 12 || H === 24) ? "AM" : "PM";
        timeString = h + timeString.substr(2, 3) + " " + ampm;
        return timeString;
    }
    
    return (
        <div className="train-2 parent-center">
            <h3 className="train-header" >Train Schedule For:</h3>
            <h2 className="child-center">{station === "Swarthmore" ? "Swarthmore Station" : "" 
            || station === "Market%20East" ? "Jefferson Station" : "" 
            || station === "Suburban%20Station" ? "Suburban Station" : ""
            || station === "30th%20Street%20Station" ? "30th St Station" : ""}
            </h2>
            <br></br>
            <button className="train-station clear-btn child-center" style={station === "Swarthmore" ? {fontWeight: "700"} : {fontWeight: "400"}} type="button" onClick={event => {
                setStation("Swarthmore"); 
                dateCreate("Swarthmore");
            }}>Swarthmore</button>
            <button className="clear-btn child-center" style={station === "Market%20East" ? {fontWeight: "700"} : {fontWeight: "400"}} type="button" onClick={event => {
                setStation("Market%20East"); 
                dateCreate("Market%20East");
            }}>Jefferson</button>
            <button className="train-station clear-btn child-center" style={station === "Suburban%20Station" ? {fontWeight: "700"} : {fontWeight: "400"}} type="button" onClick={event => {
                setStation("Suburban%20Station"); 
                dateCreate("Suburban%20Station");
            }}>Suburban</button>
            <button className="train-station clear-btn child-center" style={station === "30th%20Street%20Station" ? {fontWeight: "700"} : {fontWeight: "400"}} type="button" onClick={event => {
                setStation("30th%20Street%20Station"); 
                dateCreate("30th%20Street%20Station");
            }}>30th St</button>
            <div className="trainDirections">
                <div className="northTrain">
                    <h4>{Sschedule ? "Northbound" : ""}</h4>
                    {
                        Nschedule && Nschedule !== undefined && Nschedule.map((train, index) => {
                            return (
                                <div>
                                    <p>To {train.destination}</p>
                                    <p>Next Station: {train.next_station ? train.next_station : "N/A"}</p>
                                    <p>Scheduled Time: {convert24to12time(train.sched_time.slice(11))}</p>
                                    <p>Status: {train.status}</p>
                                    <br></br>
                                </div>
                                
                            )
                        })
                    }
                </div>
                <div className="southTrain">
                    <h4>{Sschedule ? "Southbound" : ""}</h4>
                    {
                        Sschedule && Sschedule !== undefined && Sschedule.map((train, index) => {
                            return (
                                <div>
                                    <p>To {train.destination}</p>
                                    <p>Next Station: {train.next_station ? train.next_station : "N/A"}</p>
                                    <p>Scheduled Time: {convert24to12time(train.sched_time.slice(11))}</p>
                                    <p>Status: {train.status}</p>
                                    <br></br>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default TrainSchedule;